/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleQueryPolicyId extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScheduleQueryPolicyId");
    }

    getFixupPrototypeFunction() { return ScheduleQueryPolicyId.fixupPrototype; }

    static newInstance(model: Partial<ScheduleQueryPolicyId>): ScheduleQueryPolicyId {
        let obj = Object.assign(new ScheduleQueryPolicyId(), model);
        ScheduleQueryPolicyId.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleQueryPolicyId>): ScheduleQueryPolicyId {
        if (!model) return null;
        return ScheduleQueryPolicyId.newInstance(<ScheduleQueryPolicyId> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleQueryPolicyId) {
        if (!obj) return;

        models.ScheduleQueryPolicyId.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleQueryPolicyId): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleQueryPolicyId.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy IDs targeted by the Schedule
     */
    policy_ids: Array<string>;

}
